import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-about-us/src/assets/about-us.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')